import type { SearchFilterUsagesSummary } from 'search-filter/types';
import StringUtils from 'util/StringUtils';

const readableEntityType = (entityType: string, usages: number) => {
  switch (entityType) {
    case 'SEARCH':
      return StringUtils.pluralize(usages, 'saved search', 'saved searches');
    case 'DASHBOARD_WIDGET':
      return StringUtils.pluralize(usages, 'dashboard widget', 'dashboard widgets');
    case 'EVENT_DEFINITION':
      return StringUtils.pluralize(usages, 'event definition', 'event definitions');
    case 'SIGMA_RULE':
      return StringUtils.pluralize(usages, 'sigma rule', 'sigma rules');
    default:
      return entityType;
  }
};

const readableFilterUsagesSummary = (summary: SearchFilterUsagesSummary['summary']) => summary.map(({ usages, type }) => `${usages} ${readableEntityType(type, usages)}`).join(', ');

export default readableFilterUsagesSummary;
